<template>
  <drawer-head subTitle="数据结构"></drawer-head>
</template>
<script>
import DrawerHead from "@components/frontline/DrawerHead";
export default {
  name: "DataTree",
  components: {
    DrawerHead,
  },
};
</script>
